import "../sass/style.scss";
import "./lottie-init";
import Plyr from "plyr";
import throttle from "lodash.throttle";
import Slide from "./modules/slide";
import { cardSlider } from "./sliderPosition";
import detectScreenArea from "./detectScreenArea";
import customCursor from "./customCursor";
import normalize from "./normalizeWheel";
import scrollDepth from "scroll-depth";

// Vars
const $scrollContainer = document.querySelector("#scroll-container");
let pageIndex;
let vh = window.innerHeight * 0.01; // vertical height
let viewportWidth;
const scenes = [];
let clicked = false,
    clickX,
    scrollLeft,
    walk,
    clickPageX;

const circularData = [
    {
        title: "Consultation with Specialist Doctor",
        content:
            "If necessary, the Specialist will send the patient for secondary diagnostic tests.",
    },
    {
        title: "Secondary Diagnostic Tests",
        content:
            "Further radiology and pathology scans and tests are conducted to provide a more comprehensive diagnosis.",
    },
    {
        title: "Review of Test Results",
        content:
            "The Secondary Diagnostic Test Results are sent back to the Specialist for review.",
    },
    {
        title: "Treatment Plan for Patient",
        content:
            "Our multidisciplinary team of medical professionals is then able to provide a treatment plan swiftly with the help of our effective ancillary and diagnostic services.",
    },
];

//-- Init
let tour = JSON.parse(localStorage.getItem("intro"));
if (!tour) {
    $(".overlay").css("display", "flex").fadeIn();
    localStorage.setItem("intro", true);
}

// Set css variable
document.documentElement.style.setProperty("--vh", `${vh}px`);

// Journey slide
new Slide({
    container: "#mobile-only-slider",
    next: ".button--nav-right",
    prev: ".button--nav-left",
});

// Card slider
if ($(window).width() <= 768) {
    initCardSlider();
}

// Plyr
const player = new Plyr("#player");

// Init scrollmagic controller
const controller = new ScrollMagic.Controller({
    container: "#scroll-container",
    globalSceneOptions: {
        duration: $(window).width(),
        triggerHook: 0.5,
        reverse: true,
    },
    vertical: false,
});

controller.scrollTo(function (target) {
    gsap.to("#scroll-container", {
        duration: 1.5,
        scrollTo: {
            x: target,
            autoKill: true,
        },
        ease: Back.easeOut.config(1.8),
    });
});

const $pages = $("#scroll-container > .page");
const $dotNavContainer = document.querySelector("#dot-navigation-wrapper");
const $sideMenuWrapper = document.querySelector(".side-menu-wrapper");
const $dotNav = document.createElement("div");
let $navMenu;

$dotNav.classList.add("dot-navigation");
$dotNavContainer.querySelector(".container").appendChild($dotNav);

$pages.each(function () {
    if ($pages.length < 1) return;

    const title = $(this).data("title");
    const hash = this.id;

    // Build the navigation
    const $navMenu = document.createElement("a");
    const $navMenuTitle = document.createElement("span");
    const $navCircle = document.createElement("span");
    const $navLine = document.createElement("span");

    $navMenu.classList.add("dot-navigation__menu", "anchor-menu");
    $navCircle.classList.add("dot-navigation__circle");
    $navLine.classList.add("dot-navigation__line");
    $navMenu.setAttribute("id", "anchor-" + hash);
    $navMenu.setAttribute("href", `#${hash}`);

    $navMenuTitle.classList.add("dot-navigation__title");
    $navMenuTitle.textContent = title;
    $navMenu.appendChild($navCircle);
    $navMenu.appendChild($navMenuTitle);
    $navMenu.appendChild($navLine);
    $dotNav.appendChild($navMenu);

    const titleWidth = $($navMenuTitle).width();
    $($navCircle).hover(
        function () {
            gsap.to($navMenuTitle, {
                duration: 0.15,
                left: ((titleWidth + 6) / 2) * -1,
                autoAlpha: 1,
                width: titleWidth,
                transformOrigin: "left center",
                ease: Expo.easeInOut,
            });
        },
        function () {
            gsap.to($navMenuTitle, {
                duration: 0.3,
                autoAlpha: 0,
                width: 0,
                ease: Expo.easeInOut,
            });
        }
    );

    const scrollScene = new ScrollMagic.Scene({ triggerElement: "#" + this.id })
        .setClassToggle(`#anchor-${hash}`, "active")
        .addTo(controller);

    scrollScene.on("enter", function (event) {
        const id = event.target.triggerElement().id;
        const el = $sideMenuWrapper.querySelector(`a[href="#${id}"]`);
        const links = $sideMenuWrapper.querySelectorAll(".anchor-menu");
        links.forEach((i) => i.classList.remove("active"));

        el.classList.add("active");

        const index = $navs.index($(".active"));
        const scrollDepth = (index + 1) / $pages.length * 100 + '%'

        const dataObject = {
            event: "customScrollDepth",
            onyx_scroll_treshold: scrollDepth,
            onyx_page_label: $($navs.eq(index)[0]).find('.dot-navigation__title').text(),
        };

        if (typeof dataLayer != "undefined") {
            dataLayer.push(dataObject);
        }
    });

    scenes.push(scrollScene);
});

$($dotNav).clone().appendTo($sideMenuWrapper);

const $navs = $(".anchor-menu");

document.querySelectorAll("a[href^='#']").forEach((item) =>
    item.addEventListener("click", function (e) {
        const id = this.getAttribute("href");
        const anchor = "#anchor-" + id.split("").slice("1").join("");

        if (id.length > 0) {
            e.preventDefault();

            controller.scrollTo(id);
            if (window.history && window.history.pushState) {
                history.pushState("", document.title, id);
                player.pause();
            }
        }
    })
);

const circular = document.querySelector(".circular");
const circularImgs = circular.querySelectorAll(".circular__img");
const circularTitle = $(".rotating-view__title");
const circularInner = $(".circular__inner");
const circularContent = $(".rotating-view__content");
const circularCurrentPage = $(".pagination__current");
$("#rotating-view .pagination__of").text(circularData.length);
const setCircularContent = (idx) => {
    circularTitle.text(circularData[idx].title);
    circularContent.text(circularData[idx].content);
    circularCurrentPage.text(idx + 1);
};

setCircularContent(0);
let trackRotation = 0;
let nextIdx = 0;

let idx = 0;
function onWheel(event) {
    event.preventDefault();
    let newIndex;
    const UP = normalize(event) > 0;

    pageIndex = $navs.index($(".active"));

    //move inner slides
    if (pageIndex === 2) {
        if (nextIdx === 0) {
            if (UP) {
                //go to previous outer slide
                newIndex = pageIndex - 1;
            } else {
                //go to next inner slide
                return nextCircularSlide();
            }
        } else if (nextIdx < circularData.length - 1) {
            // go to next/previous inner slide
            return UP ? prevCircularSlide() : nextCircularSlide();
        } else if (nextIdx === circularData.length - 1) {
            if (UP) {
                //go to previous inner slide
                return prevCircularSlide();
            } else {
                // go to next outer slide
                newIndex = pageIndex + 1;
            }
        }
    }

    // move main slides
    newIndex = UP ? pageIndex - 1 : pageIndex + 1;

    if (newIndex !== pageIndex && newIndex >= 0 && newIndex < $navs.length) {
        $navs.eq(newIndex)[0].click();
    }
}

const rotateSlides = () => {
    gsap.to(circular, {
        duration: 1,
        rotation: trackRotation,
        force3D: true,
        ease: Back.easeOut,
    });

    circularImgs.forEach(function (img) {
        gsap.to(img, {
            duration: 1,
            rotation: trackRotation * -1,
            ease: Back.easeOut,
        });
    });
};

const nextCircularSlide = () => {
    trackRotation += 90;
    nextIdx++;
    rotateSlides();
    setCircularContent(nextIdx);
    updateCircularBtns();

    const dataObject = {
        event: "slideChange",
        onyx_slide_val: (nextIdx + 1)
    };

    if (typeof dataLayer != "undefined") {
        dataLayer.push(dataObject);
    }
};

const prevCircularSlide = () => {
    trackRotation -= 90;
    nextIdx--;
    rotateSlides();
    setCircularContent(nextIdx);
    updateCircularBtns();
};

const nextBtn = document.querySelector(".button--nav-right");
const prevBtn = document.querySelector(".button--nav-left");

const updateCircularBtns = () => {
    if (nextIdx === 0) {
        prevBtn.classList.add("is-invisible");
    } else if (nextIdx < circularData.length - 1) {
        prevBtn.classList.remove("is-invisible");
        nextBtn.classList.remove("is-invisible");
    } else {
        nextBtn.classList.add("is-invisible");
    }
};

nextBtn.addEventListener("click", nextCircularSlide);
prevBtn.addEventListener("click", prevCircularSlide);

function initCardSlider() {
    const slider = new Slide({
        container: "#card-slider",
        next: ".button--nav-right",
        prev: ".button--nav-left",
    });

    return slider;
}

function updateScrollPos(e) {
    e.preventDefault();
    $("html").css("cursor", "grabbing");
    const x = e.clientX || e.touches[0].clientX;
    const move =
        scrollLeft + (clickPageX - (e.pageX || e.touches[0].pageX)) * 2;
    walk = x - clickX;

    $("#scroll-container").scrollLeft(move);
}

function openSideMenu(e) {
    if (!e.target.closest(".burger-menu")) return;

    gsap.fromTo(
        $("#side-menu"),
        {
            autoAlpha: 0,
            x: $("#side-menu").width() * -1,
        },
        {
            duration: 0.3,
            autoAlpha: 1,
            display: "block",
            ease: Expo.easeInOut,
            x: 0,
        }
    );
}

function closeSideMenu(e) {
    if (!e.target.closest(".close") && !e.target.closest(".anchor-menu"))
        return;

    gsap.to($("#side-menu"), {
        duration: 0.3,
        autoAlpha: 0,
        x: $("#side-menu").width() * -1,
        ease: Expo.easeInOut,
    });
}

let cursorIdx = 0;
function clickNavigate(e) {
    if (e.target.closest(".button")) return;
    if (detectScreenArea(e) === "left") {
        if (pageIndex > 0 && pageIndex < $navs.length) {
            cursorIdx = pageIndex - 1;
        }
        $navs.eq(cursorIdx)[0].click();
    } else if (detectScreenArea(e) === "right") {
        if (pageIndex >= 0 && pageIndex < $navs.length - 1) {
            cursorIdx = pageIndex + 1;
        }
        $navs.eq(cursorIdx)[0].click();
    }
}

//-- Event Handler
// Handle mouse down
function handleMouseDown(e) {
    pageIndex = $navs.index($(".active"));
    clicked = true;
    clickX = e.clientX || e.touches[0].clientX;
    clickPageX = e.pageX || e.touches[0].pageX;
    walk = 0; //reset walk value
    scrollLeft = $("#scroll-container").scrollLeft();
}

function handleMouseUp(e) {
    pageIndex = $navs.index($(".active"));
    let newIndex;
    newIndex = pageIndex;
    clicked = false;

    // if (walk > 1) {
    //   newIndex = currentIndex -1
    // } else if (walk < -1) {
    //   newIndex = currentIndex
    // }

    $("html").css("cursor", "auto");

    if (Math.abs(walk) > 2) {
        if (newIndex >= 0 && newIndex < $navs.length) {
            $navs.eq(newIndex)[0].click();
        }
    } else {
        clickNavigate(e);
    }
}

function handleClick(e) {
    openSideMenu(e);
    closeSideMenu(e);
}

function handleResize(e) {
    // update on resize
    vh = window.innerHeight * 0.01;
    viewportWidth = $(window).width();
    scrollLeft = 0;
    walk = 0;

    scenes.forEach((scene) => {
        if (typeof scene === "object") {
            scene.refresh();
            scene.update();
            scenes.push(Math.ceil(scene.scrollOffset()));
        } else {
            scene = 0;
        }
    });

    $navs.eq(0)[0].click();

    if (window.innerWidth <= 768) {
        initCardSlider();
        console.log("init");
    } else {
        console.log(initCardSlider().destroy());
    }
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}

// Mousedown
$("#scroll-container").on("mousedown touchstart", handleMouseDown);

// Mouseup
$("#scroll-container").on("mouseup touchend", handleMouseUp);

// Mousemove
$("#scroll-container").on("mousemove touchmove", function (e) {
    clicked && updateScrollPos(e);
});

$(".overlay .close").on("click", function () {
    $(this).parent().fadeOut();
});

// Single click listener for every needs === faster
$(document).on("click", handleClick);

// For Custom cursor
$(window).on("mousemove", customCursor);

// Resize
$(window).on("resize", handleResize);

// Scroll wheel
$scrollContainer.addEventListener(
    "wheel",
    throttle(onWheel, 500, { trailing: false }),
    { passive: false }
);
